<template>
  <div :endpoint='api.$.evedpaycard.cards'>
    <slot name='title' />
    <div class='no-data' v-if='cards && !cards.length'>
      <div>
        <i class='icon fas fa-credit-card'></i>
        <h3>No Cards</h3>
        <p>Once you are assigned a card it will appear here</p>
      </div>
    </div>
    <div v-for='(card, i) in cards' :key="card.id" @click="() => redirectToCardTransactions(card)">
      <h6 v-if='showHeader(card, i)'>
        {{ headerText(card) }}
      </h6>
      <ed-notice class='card'>
        <div class='details'>
          <i class='open icon fal fa-angle-right'></i>
          <div class='preview'>
            <div class='image'>
              <i class='icon fal fa-credit-card'></i>
              <div class="logo">
                <img style="display:none" src='https://d1a4bxjw35af21.cloudfront.net/images_en/eved-pay-logo.svg' height='16' />
              </div>
            </div>
          </div>
          <p><strong>{{ showCardNameForDifferentStatus(card) }}</strong></p>
          <p>{{ card.holder }}</p>
          <p>{{ card.division }}</p>
          <p>{{ card.date }}</p>
        </div>
        <table class='summary'>
          <tr>
            <td>Initial load</td>
            <td class='text-right'><v-money>{{ card.initialLoad }}</v-money></td>
          </tr>
          <tr>
            <td>Refills</td>
            <td class='text-right'><v-money>{{ card.refills }}</v-money></td>
          </tr>
          <tr>
            <td>Pending requests</td>
            <td class='text-right'><v-money>{{ card.pendingRequest }}</v-money></td>
          </tr>
          <tr>
            <td>Spent</td>
            <td class='text-right'><v-money>{{ card.spent }}</v-money></td>
          </tr>
          <tr>
            <td>Returned</td>
            <td class='text-right'><v-money>{{ card.returned }}</v-money></td>
          </tr>
          <tr>
            <td><strong>Balance</strong></td>
            <td class='text-right'><strong><v-money>{{ card.balance }}</v-money></strong></td>
          </tr>
        </table>
      </ed-notice>
    </div>
  </div>
</template>

<script>
export default {
  alias: 'evedpaycards',
  data() {
    return {
      cards: null,
      dateFormat: null
    }
  },
  created() {
    this.initializeData()
  },
  computed: {
    moment() { return global.moment }
  },
  methods: {
    async initializeData() {
      await this.fetchCards()
    },
    async fetchCards() {
      this.api.forms.post(this.api.$.evedpaycard.cards, {
        sort: 'CardGroup',
        dir: 'DESC',
        start: 0,
        limit: 100,
        isLiveGrid: true,
        filter: {
          searchTerm: ''
        }
      }).then(r => {
        this.cards = r.data.Data
        .map(card => ({
          name: 'EvedPay Card' + `${card.CardNumber ? ' ...' + card.CardNumber : ''}`,
          holder: card.Holder,
          holderUserId: card.HolderUserID,
          division: card.Division,
          divisionId: card.DivisionId,
          initialLoad: card.InitialLoad,
          refills: card.Refills,
          pendingRequest: card.Pending,
          spent: card.Spent,
          returned: card.ReturnedAmount,
          balance: card.Balance,
          id: card.Id,
          cardNumber: card.CardNumber,
          accId: card.AccountId,
          status: card.CardStatus,
          createdDate: card.CreatedDate
        }))
      })
    },
    redirectToCardTransactions(card) {
      this.$router.push({
        path: `/evedpay/cardtransactions/?cardid=${card.id}`,
        query: {
          ...this.$route.query,
          cardNumber: card.cardNumber
        }
      })
    },
    headerText(card) {
      const status = card.status

      if (status === 'Locked - Lost/Stolen') {
        return 'Lost/Stolen'
      } else {
        return `${status}`
      }
    },
    showCardNameForDifferentStatus(card) {
      const status = card.status
      this.dateFormat = this.$user &&
        this.$user.sessionSettings &&
        this.$user.sessionSettings.DateAndTimeFormats &&
        this.$user.sessionSettings.DateAndTimeFormats.MomentDateFormat
        ? this.$user.sessionSettings.DateAndTimeFormats.MomentDateFormat
        : 'MM-DD-YYYY'
      const date = this.moment(card.createdDate).format(this.dateFormat)

      if (status === 'Pending Approval' || status === 'Processing' || status === 'Rejected') {
        return 'Card Requested ' + `${date}`
      } else {
        return card.name
      }
    },
    showHeader(card, index) {
      if (index === 0) return true

      const previousCard = this.cards[index - 1]
      return this.headerText(card) !== this.headerText(previousCard)
    }
  }
}

</script>

<style lang='scss' scoped>
@import "~@/assets/sass/_variables.scss";

.no-data {
  height: calc(100vh - 15em);
  width: 75%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  h3 {
    margin-top: 1.6em;
    margin-bottom: 0.2em;
    font-weight: 600;
  }
  h3, p, .icon {
    color: #4e2683;
  }
  p {
    line-height: 1.2em;
  }

  .icon {
    font-size: 5em;
    &:after {
      position: absolute;
      display: block;
      content: '';
      left: 50%;
      top: 50%;
      margin-top: -80px;
      margin-left: -80px;
      width: 160px;
      height: 160px;
      border-radius: 50%;
      background: rgba(78,38,131,0.15);
      z-index: -1;
    }
  }
}

.card {
  border-radius: 6px;
  box-shadow: 1px 3px 5px 0px rgba(0,0,0,0.15);
  >>> &.no-icon .icon-wrapper.no-icon {
    min-width: 0;
    display: none;
  }
  border-color: #f2f2f2 !important;
  p {
    margin-bottom: 5px;
  }

  .details {
    border-bottom: 1px solid #ddd;
  }
}
.summary {
  width: 100%;
}
.preview {
  .image {
    background: linear-gradient(315deg, #8C407B 0%, #63417E 100%);
    float: left;
    margin: 0.5rem 1rem 0.5rem 0;
    height: 56px;
    border-radius: 7px;
    position: relative;
    img {
      height: 10px;
      width: auto;
      position: absolute;
      right: 5px;
      margin-top: 3px;
      display: inline-block !important;
    }
  }
  .icon {
    color: #63417E;
    font-size: 64px;
    // padding: 0.5rem 1rem 0.5rem 0;
    margin-top: -4px;
    float: left;
  }
}
.open.icon {
  position: absolute;
  right: 15px;
  font-size: 32px;
  top: 25px;
}

</style>



// WEBPACK FOOTER //
// src/components/_modules/EvedPay/cards.vue